'use strict';

angular.module('ntmApp')
  .controller('listGridEditDialogController', ['$scope', '$uibModalInstance', 'data', 'ListGridConstants', 'FlashService', 'Utils', 'EditForm',
      function ($scope, $uibModalInstance, data, ListGridConstants, FlashService, Utils, EditForm) {

          $scope.editMode = data.action;
          $scope.searchableData = data.searchableData;

          $scope.close = function (event) {

              if (!$scope.editForm.form.$dirty) {
                  $uibModalInstance.dismiss();
              } else {
                  if (event) {
                      event.preventDefault();
                  }
                  var modal = Utils.OpenModal('Save pending changes?', 'ng1/src/common/confirmationModal.html', 'ModalController');

                  modal.result.then(function (leave) {
                      if (leave === 'no') {
                          $uibModalInstance.dismiss();
                      } else if (leave === 'yes') {
                          if (!$scope.editForm.form.$valid) {
                              FlashService.Error('Please, fill all required fields', true);
                          } else {
                              $scope.saveAndClose();
                          }
                      }
                  });
              }
          };

          $scope.runAction = function (action) {
              data.runAction(action, $scope.editForm.getModel());
          };

          $scope.itemSelected = function () {
              data.model = $scope.searchableData.navigate(false, $scope.searchableData.searchItem);
              $scope.editForm.ComposeData();
          };

          $scope.navigate = function (next) {
              data.model = $scope.searchableData.navigate(next);
              $scope.editForm.ComposeData();
          };

          $scope.getRowActions = function () {
              if (!data.buttons) {
                  return [];
              }

              return data.buttons.filter(function (item) { return item.showOnSelect; });
          };

          $scope.saveData = function () {
              $scope.editForm.SaveData().then(function (result) {
                  if (result.success) {
                      data.refreshGridData(result.data, $scope.editMode);
                      $scope.editMode = ListGridConstants.Operation.EDIT;
                      $scope.editForm.action = ListGridConstants.Operation.EDIT;
                  }
              });
          };

          $scope.saveAndClose = function () {
              $scope.editForm.SaveData().then(function (result) {
                  if (result.success) {
                      data.refreshGridData(result.data, $scope.editMode);
                      $uibModalInstance.dismiss();
                  }
              });
          };

          $scope.saveAndOpenRecurrence = function () {
              if ($scope.editForm.form.$dirty) {
                  $scope.editForm.SaveData().then(function (result) {
                      if (result.success) {
                          data.refreshGridData(result.data, $scope.editMode);
                          $scope.editMode = ListGridConstants.Operation.EDIT;
                          $scope.editForm.action = ListGridConstants.Operation.EDIT;
                          $scope.runAction($scope.getRecurrence());
                      }
                  });
              } else {
                  $scope.runAction($scope.getRecurrence());
              }
          };
         

          $scope.saveAndAddNew = function () {
              $scope.editForm.SaveData().then(function (result) {
                  if (result.success) {
                      data.refreshGridData(result.data, $scope.editMode);
                      $scope.addNew();
                  }
              });
          };

          $scope.delete = function () {
              data.deleteRow();
          };

          $scope.addNew = function () {
              $uibModalInstance.dismiss();
              data.addNew();
          };

          $scope.cancel = function () {
              $scope.editForm.Cancel();
              $uibModalInstance.dismiss();
          };

          $scope.dismiss = function () {
              $uibModalInstance.dismiss();
          };

          $scope.getRecurrence = function () {
              return data.buttons ? data.buttons.filter(function (action) { return action.buttonType === 'RECURRENCE'; })[0] : null;
          };

          $scope.getRecurrenceBtnLabel = function () {
              var recurrence = $scope.getRecurrence();
              return $scope.editForm.form.$dirty ? 'Save and ' + recurrence.buttonName : recurrence.buttonName;
          };

          $scope.showAddButton = function () {
              return data.listGridActions ? data.listGridActions.showAddButton(ListGridConstants.EditType.DIALOG, $scope.editMode) : true;
          };

          $scope.showDeleteIcon = function () {
              return data.listGridActions && data.listGridActions.rowActions ? data.listGridActions.rowActions.showDeleteIcon() : true;
          };

          $scope.$on('modal.closing', function (event, reason) {
              if (reason === 'backdrop click') {
                  event.preventDefault();
                  $scope.close();
              }
          });

          function initData() {
              $scope.editForm = new EditForm(data);
          }

          initData();

      }]);
